import React from "react"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import style from "./style.module.scss"

export type Item = {
  label: string
  value: string
}

type Props = {
  items: Item[]
  onItemClick: (item: Item) => void
  onEmptyClick: () => void
}

/**
 * リストを表示するコンポーネントです
 * 座席のリストや、ロケーションのリストなど
 */
export default function ItemList ({
  items,
  onItemClick,
  onEmptyClick,
}: Props) {
  return (
    <div className={style.frame}>
      <List className={style.list} component="nav">
        {items.length === 0 && (
          <ListItem button onClick={onEmptyClick}>
            <ListItemText primary={"該当する施設はありません"} />
          </ListItem>
        )}
        {items.map((item, i) => {
          return (
            <ListItem button divider={i < items.length - 1} key={item.value} onClick={() => onItemClick(item)}>
              <ListItemText primary={item.label} />
            </ListItem>
          )
        })}
      </List>
    </div>
  )
}
